import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("babiSolde_api");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des categories

export const listeDesCategories = async (page, size, param) => {
  // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
  return await axios.get(
    `${BASE_URL}/parametrage/categorie/all?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

//liste categorie sans filters
export const listeCategoriesSansFiltre = async () => {
  // return await axios.get(`${BASE_URL}/parametres/allCategorie`), {});
  return await axios.get(`${BASE_URL}/parametrage/categorie/allCategories`, {});
};

// Enregiste des categories

export const enregistrerCategories = async (categories) => {
  return await axios.post(`${BASE_URL}/parametrage/categorie`, categories);
};

// modifie categorie

export const modifierCategorieById = async (categorieId, categorie) => {
  return await axios.put(
    `${BASE_URL}/parametrage/categorie/${categorieId}`,
    categorie
  );
};

// supprimer une categorie

export const supprimerUneCategorie = async (categorieId) => {
  return await axios.delete(`${BASE_URL}/parametrage/categorie/${categorieId}`);
};
